import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: '機能',

  // 選択サービス名
  serviceName: null,

  // model
  functionModel: []
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {functionParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceFunction'],
        ['v1ServiceFunctionListGet'],
        [functionParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setServiceName', res[0].data.serviceName)
            commit('setFunctionModel', res[0].data.serviceFunctions)
            console.log('functionModel', state.functionModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  }
}

const mutations = {
  // service name
  setServiceName (state, str) {
    state.serviceName = str
  },

  // model
  setFunctionModel (state, data) {
    Vue.set(state, 'functionModel', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
